import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomButton from "../CustomButton";
import PetImg from "../../assets/images/pet-img.jpg";
import { TbComet } from "react-icons/tb";
import "./StarsCall.css";

export default function StarsCall(props) {
  return (
    <Container className="stars-call-section">
      <Row>
        <Col className="stars-call-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <TbComet
              style={{ color: props.iconColor }}
              className="stars-call-icon"
            />
            MURAL DAS ESTRELINHAS PET
          </h2>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className="stars-call-third-col">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            Veja aqui todos os companheirinhos que viraram uma estrelinha no
            céu. Com muito carinho criamos esta homenagem aos pets.
          </p>
          <CustomButton
            className="primary-btn"
            variant="primary"
            href="/estrelinhas/"
            icon=""
            content="VER ESTRELINHAS"
            backgroundColor={props.primaryBtnColor}
            fontFamily="Unageo-Bold"
            fontColor={props.white}
            fontSize={20}
            width={240}
            borderColor={props.primaryBtnColor}
            disabled={false}
          />
        </Col>
        <Col lg={{ span: 6, order: "first" }} className="stars-call-second-col">
          <div className="stars-call-img-container">
            <img src={PetImg} alt="pet" />
            <div className="stars-call-img-overlay" />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
